import { Path } from 'paper';

import { type GenericElement } from '../../../lib/element';
import { type FreedrawElement } from '../../freedraw';

export const getPositionedPaperPath = (
  element: GenericElement,
  groupX: number,
  groupY: number,
) => {
  if (element.shape == null) return '' as unknown as paper.PathItem;

  const elementPath = new Path(element.shape.data) as paper.PathItem;
  if (element.shape.type === 'area') {
    elementPath.closePath();
  }

  if (element.shape.type === 'line') {
    elementPath.strokeWidth = (element as FreedrawElement).strokeWidth ?? 3;
  }

  elementPath.translate({
    x: -groupX,
    y: -groupY,
  });

  return elementPath;
};

export const computeBooleanShapeData = (
  elementsInGroup: GenericElement[],
  groupX: number,
  groupY: number,
): string => {
  if (elementsInGroup.length === 0) return '';

  const firstElement = {
    ...elementsInGroup[0],
    shape: { ...elementsInGroup[0].shape },
  };

  if (firstElement.booleanMode === 'subtract') {
    firstElement.shape.data = '';
  }

  let resultPaperPath = getPositionedPaperPath(firstElement, groupX, groupY);

  for (const el of elementsInGroup.slice(1)) {
    const elementPath = getPositionedPaperPath(el, groupX, groupY);

    switch (el.booleanMode) {
      case 'subtract':
        resultPaperPath = resultPaperPath.subtract(elementPath);
        break;
      case 'intersect':
        resultPaperPath = resultPaperPath.exclude(elementPath);
        break;
      case 'union':
        resultPaperPath = resultPaperPath.unite(elementPath);
        break;
    }
  }

  return resultPaperPath.pathData;
};
